import { TOGGLE_TO_IMAGE, TOGGLE_TO_VIDEO } from './types'
import { toggleImageAction, toggleVideoAction } from './actions'
import { toggleReducer } from './reducer'
import { ToggleMedia } from './ToggleMedia'

export {
  TOGGLE_TO_IMAGE,
  TOGGLE_TO_VIDEO,
  toggleReducer,
  toggleImageAction,
  toggleVideoAction,
  ToggleMedia
}
